// Cihaz kimliği + ayrıntılı istemci bilgisi (giriş kayıtları için) + giriş parolası jetonu (oturum süresince sekmede)
const DEV_KEY = "ge_device_id";
const GATE_KEY = "ge_gate";

export function deviceId() {
  let d = localStorage.getItem(DEV_KEY) || "";
  if (!/^[A-Za-z0-9_-]{8,64}$/.test(d)) {
    d = ((window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 14)}`).replace(/[^A-Za-z0-9_-]/g, "");
    localStorage.setItem(DEV_KEY, d);
  }
  return d;
}

export function getGateToken() {
  try {
    const { token, exp } = JSON.parse(sessionStorage.getItem(GATE_KEY) || "{}");
    return token && exp > Date.now() + 15000 ? token : "";
  } catch { return ""; }
}
export const setGateToken = (token, expiresIn) => sessionStorage.setItem(GATE_KEY, JSON.stringify({ token, exp: Date.now() + (expiresIn || 1800) * 1000 }));
export const clearGateToken = () => sessionStorage.removeItem(GATE_KEY);

const gpu = () => {
  try {
    const gl = document.createElement("canvas").getContext("webgl");
    const ext = gl && gl.getExtension("WEBGL_debug_renderer_info");
    return ext ? String(gl.getParameter(ext.UNMASKED_RENDERER_WEBGL) || "") : "";
  } catch { return ""; }
};

async function collect() {
  const n = navigator, s = window.screen || {}, c = n.connection || n.mozConnection || n.webkitConnection || {};
  const info = {
    screen: `${s.width}x${s.height}`, viewport: `${window.innerWidth}x${window.innerHeight}`, dpr: window.devicePixelRatio || 1,
    color_depth: s.colorDepth || 0, orientation: (s.orientation && s.orientation.type) || "",
    lang: n.language || "", langs: (n.languages || []).slice(0, 4), tz: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    tz_offset: -new Date().getTimezoneOffset(), local_time: new Date().toString().slice(0, 33),
    platform: (n.userAgentData && n.userAgentData.platform) || n.platform || "", cores: n.hardwareConcurrency || 0, memory: n.deviceMemory || 0,
    touch: n.maxTouchPoints || 0, conn_type: c.type || "", conn_eff: c.effectiveType || "", conn_down: c.downlink || 0, conn_rtt: c.rtt || 0,
    save_data: !!c.saveData, standalone: !!((window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) || n.standalone),
    referrer: document.referrer || "", cookies: !!n.cookieEnabled, dnt: n.doNotTrack === "1", gpu: gpu(),
  };
  if (n.userAgentData) {
    info.mobile = !!n.userAgentData.mobile;
    try {
      const h = await n.userAgentData.getHighEntropyValues(["model", "platformVersion", "architecture", "bitness", "fullVersionList"]);
      info.model = h.model || ""; info.platform_version = h.platformVersion || ""; info.arch = h.architecture || ""; info.bitness = h.bitness || "";
      info.brands = (h.fullVersionList || []).filter((b) => !/not.?a.?brand/i.test(b.brand)).map((b) => `${b.brand} ${b.version}`).slice(0, 4);
    } catch { /* tarayıcı izin vermedi */ }
  }
  return info;
}

let cache = null;
export const clientInfo = () => { if (!cache) cache = collect().catch(() => ({})); return cache; };
